import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'
import { scanService } from 'src/services/scan.service'

export const useUnreviewedScansCount = () => {
  const { accountId } = useParams()

  return useQuery(
    [QUERY_KEYS.SCANS_UNREVIEWED_COUNT, accountId || ''],
    () => scanService.getUnreviewedScansCount(accountId),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  )
}
